import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SlideOutComponent } from './slide-out.component';

@NgModule({
  declarations: [SlideOutComponent],
  imports: [CommonModule],
  exports: [SlideOutComponent],
})
export class SlideOutModule {}
